export const categories_old = [
    "Agence digitale",
    "Architecte",
    "Avocat",
    "Boulangerie",
    "Coiffure",
    "Comptable",
    "Consultant",
    "Dentiste",
    "Déménagement",
    "Développement web",
    "Esthétique",
    "Infographie",
    "Informatique",
    "Kinésithérapeute",
    "Librairie",
    "Livraison",
    "Magasin de vêtements",
    "Massage",
    "Maçonnerie",
    "Menuiserie",
    "Médecin",
    "Notaire",
    "Peinture",
    "Plomberie",
    "Psychologue",
    "Réparation informatique",
    "Serrurerie",
    "Spa",
    "Taxi/VTC",
    "Électricité",
    "Épicerie"
]

export const newCategories = [
  "Digital & Informatique",
  "Commerce & Vente",
  "Santé",
  "Bien-être",
  "Services juridiques",
  "Services financiers",
  "Maintenance & Bâtiment",
  "Transport & Logistique",
  "Restauration & Alimentaire",
  "Art & Design",
  "Artisanat & Production manuelle"
]

export const categories = [
  "Agriculteur",
  "Maraîcher",
  "Éleveur",
  "Pêcheur",
  "Boucher",
  "Charcutier",
  "Poissonnier",
  "Boulanger",
  "Pâtissier",
  "Chocolatier",
  "Glacier",
  "Fromager",
  "Traiteur",
  "Restaurateur",
  "Cuisinier",
  "Chef cuisinier",
  "Pizzaïolo",
  "Serveur",
  "Barista",
  "Sommelier",
  "Épicier",
  "Primeur",
  "Livreur de repas",
  "Architecte",
  "Ingénieur civil",
  "Maçon",
  "Couvreur",
  "Charpentier",
  "Menuisier",
  "Électricien",
  "Plombier",
  "Chauffagiste",
  "Frigoriste",
  "Carreleur",
  "Peintre en bâtiment",
  "Plafonneur",
  "Façadier",
  "Vitrier",
  "Serrurier",
  "Installateur de panneaux solaires",
  "Installateur domotique",
  "Technicien ascenseur",
  "Technicien HVAC",
  "Femme de ménage",
  "Agent d'entretien",
  "Laveur de vitres",
  "Nettoyeur industriel",
  "Entreprise de désinfection",
  "Dératiseur",
  "Désinsectiseur",
  "Jardinier",
  "Paysagiste",
  "Élagueur",
  "Pisciniste",
  "Chauffeur taxi",
  "Chauffeur Uber",
  "Chauffeur privé",
  "Chauffeur bus",
  "Conducteur de train",
  "Pilote avion",
  "Chauffeur poids lourd",
  "Livreur",
  "Coursier",
  "Déménageur",
  "Mécanicien automobile",
  "Garagiste",
  "Carrossier",
  "Tôlier",
  "Peintre automobile",
  "Électricien auto",
  "Dépanneur automobile",
  "Spécialiste pneus",
  "Nettoyeur automobile",
  "Vendeur automobile",
  "Contrôleur technique",
  "Médecin généraliste",
  "Médecin spécialiste",
  "Dentiste",
  "Orthodontiste",
  "Pharmacien",
  "Infirmier",
  "Kinésithérapeute",
  "Ostéopathe",
  "Psychologue",
  "Psychiatre",
  "Ambulancier",
  "Sage-femme",
  "Nutritionniste",
  "Opticien",
  "Audioprothésiste",
  "Coiffeur",
  "Barbier",
  "Esthéticienne",
  "Prothésiste ongulaire",
  "Maquilleur",
  "Masseuse",
  "Coach sportif",
  "Personal trainer",
  "Tatoueur",
  "Perceur",
  "Professeur",
  "Instituteur",
  "Formateur",
  "Coach scolaire",
  "Prof particulier",
  "Moniteur d'auto-école",
  "Commerçant",
  "Caissier",
  "Vendeur",
  "Agent immobilier",
  "Courtier",
  "Assureur",
  "Banquier",
  "Comptable",
  "Expert-comptable",
  "Avocat",
  "Notaire",
  "Huissier",
  "Juriste",
  "Conseiller fiscal",
  "Médiateur",
  "Policier",
  "Gendarme",
  "Agent de sécurité",
  "Gardien",
  "Agent de surveillance",
  "Pompier",
  "Développeur web",
  "Développeur mobile",
  "Ingénieur informatique",
  "Technicien IT",
  "Technicien réseau",
  "Cybersecurity analyst",
  "Designer UX/UI",
  "Community manager",
  "Graphiste",
  "Expert SEO",
  "Baby-sitter",
  "Nounou",
  "Aide à domicile",
  "Aide pour personnes âgées",
  "Dog sitter",
  "Promeneur de chien"
]

export const countries = [
  "Belgique",
  "France",
  "Pays-Bas",
  "Allemagne",
  "Luxembourg",
  "Italie",
  "Espagne",
  "Royaume-Uni",
  "Suisse",
  "Portugal"
];

export const cities = [
  "Bruxelles",
  "Anvers",
  "Gand",
  "Liège",
  "Charleroi",
  "Bruges",
  "Namur",
  "Leuven",
  "Mons",
  "La Louvière",
  "Tournai",
  "Hasselt",
  "Kortrijk",
  "Ostende",
  "Mechelen"
];

